import { createContext } from 'react';

import { Viewport } from './ViewportDefinition';

export const defaultValue: Viewport = null;

const ViewportContext = createContext(defaultValue);

export default ViewportContext;
